module.exports = __webpack_public_path__ + "img/08_rambutan.0daaf9c6.png";